import { MetricBaseUnit } from './metric-units.model';

type UnitCreationData = {
  name: string;
  definition: {
    definition?: `${number} ${MetricBaseUnit}` | `${number}`;
    aliases?: string[];
    prefixes?: 'short' | 'long';
  };
};

export const aliasUnitCreationData = [
  {
    name: 'GFA',
    definition: { definition: '1 m^2' },
  },
  {
    name: 'yr',
    definition: { definition: '1 year' },
  },
  {
    name: 'people',
    definition: { definition: '1' },
  },
  {
    name: 'activity',
    definition: { definition: '1' },
  },
  {
    name: 'pcs',
    definition: { definition: '1' },
  },
  {
    name: 'unit',
    definition: { definition: '1' },
  },
] as const satisfies UnitCreationData[];

export type AliasUnit = ArrayValues<typeof aliasUnitCreationData>['name'];
